export default {
  aws_appsync_graphqlEndpoint: process.env.VUE_APP_API_URL_APP_SYNC,
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: process.env.VUE_APP_API_KEY_APP_SYNC,
};